import * as clientSelector from './client'

const clientSelectors = {
    clientSelector: clientSelector
};

export default clientSelectors;